// Minimal dual-handle range slider: two overlaid native range inputs sharing one track.
// No dependency. Non-thumb areas are pointer-events:none (CSS), so both thumbs stay
// grabbable — the underlying input receives events except exactly where a thumb sits.

export function initDualRange(el, { format, onChange } = {}) {
  const lo = el.querySelector('.dr-lo');
  const hi = el.querySelector('.dr-hi');
  const fill = el.querySelector('.dr-fill');
  const fromEl = el.querySelector('.dr-from');
  const toEl = el.querySelector('.dr-to');
  const min = Number(el.dataset.min);
  const max = Number(el.dataset.max);
  const fmt = format || ((v) => String(v));

  function clampCross(changed) {
    let a = Number(lo.value), b = Number(hi.value);
    if (a > b) {
      if (changed === 'lo') { a = b; lo.value = a; }
      else { b = a; hi.value = b; }
    }
  }
  function paint() {
    const a = Number(lo.value), b = Number(hi.value);
    const span = (max - min) || 1;
    const left = ((a - min) / span) * 100;
    const right = ((b - min) / span) * 100;
    fill.style.left = left + '%';
    fill.style.width = Math.max(0, right - left) + '%';
    if (fromEl) fromEl.textContent = fmt(a);
    if (toEl) toEl.textContent = fmt(b);
  }
  const emit = () => onChange && onChange([Number(lo.value), Number(hi.value)]);

  lo.addEventListener('input', () => { clampCross('lo'); paint(); emit(); });
  hi.addEventListener('input', () => { clampCross('hi'); paint(); emit(); });
  paint();

  return {
    get: () => [Number(lo.value), Number(hi.value)],
    set: (a, b) => { lo.value = a; hi.value = b; clampCross('hi'); paint(); }
  };
}
